import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function CollegeDevelopmentCommittee() {
    const members = [
        { sr: 1, name: 'Dr. Sahadeo Aher', role: 'Chairman (Principal)' },
        { sr: 2, name: 'Management Representative', role: 'Member' },
        { sr: 3, name: 'Senior Faculty Member', role: 'Member' },
        { sr: 4, name: 'Local Body Representative', role: 'Member' },
        { sr: 5, name: 'Industry / Alumni Representative', role: 'Invitee Member' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Management › College Development Committee</p>
                <h1>College Development Committee</h1>
                <p>Steering the infrastructure and strategic development of the college.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Committee Members</h2>
                    <table className="data-table">
                        <thead><tr><th>Sr.</th><th>Name</th><th>Role</th></tr></thead>
                        <tbody>
                            {members.map(m => (
                                <tr key={m.sr}><td>{m.sr}</td><td style={{ fontWeight: 600 }}>{m.name}</td><td>{m.role}</td></tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Functions & Responsibilities</h2>
                    <ul>
                        <li>Planning and recommending developmental activities for college infrastructure.</li>
                        <li>Reviewing proposals for new academic programs and laboratories.</li>
                        <li>Advising on utilization of grants and funds from UGC, State Govt., and RUSA.</li>
                        <li>Promoting industry-academia linkages and MOU partnerships.</li>
                        <li>Monitoring implementation of development plans approved by the Governing Council.</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default CollegeDevelopmentCommittee;
